export default __webpack_public_path__ + "static/media/down.ef25ce7a.svg";